import React from 'react';

import classNames from 'classnames';

import i18n from '../../../../providers/Locale';
import ComponentType from '../../../../types/Component';
import PhoneShake from '../../../ui/icons/PhoneShake';
import Time from '../../../ui/icons/Time';

import style from './style.module.scss';

type StepsProps = {
	isFirstStep: boolean;
	onFirstStepClick: () => void;
};

const Steps: ComponentType<StepsProps> = ({ isFirstStep, onFirstStepClick }) => {
	return (
		<div className={style.Steps}>
			<div
				className={classNames([style.step, isFirstStep && style.active])}
				onClick={onFirstStepClick}>
				<Time />
				{i18n('time')}
			</div>
			<div className={classNames([style.step, !isFirstStep && style.active])}>
				<PhoneShake />
				{i18n('contacts')}
			</div>
		</div>
	);
};

export default Steps;
